<template>
  <div class="register-container">
    <div class="register-card">
      <!-- 注册方式标签页 -->
      <div class="register-tabs">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'phone' }"
          @click="switchTab('phone')"
        >
          手机号注册
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'account' }"
          @click="switchTab('account')"
        >
          账号密码注册
        </div>
      </div>

      <!-- 手机号注册表单 -->
      <el-form
        v-if="activeTab === 'phone'"
        ref="phoneForm"
        :model="phoneForm"
        :rules="phoneRules"
        class="register-form"
      >
        <!-- 手机号输入 -->
        <el-form-item prop="phone">
          <div class="input-wrapper">
            <img
              src="@/assets/image/sjh1.png"
              class="input-icon"
              alt="手机图标"
            >
            <el-input
              v-model="phoneForm.phone"
              placeholder="请输入你的手机号码"
              name="phone"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </div>
        </el-form-item>

        <!-- 验证码输入 -->
        <el-form-item prop="code">
          <div class="input-wrapper code-input">
            <img
              src="@/assets/image/code1.png"
              class="input-icon"
              alt="验证码图标"
            >
            <el-input
              v-model="phoneForm.code"
              placeholder="请输入你的验证码"
              name="code"
              type="text"
              tabindex="2"
              auto-complete="off"
            />
            <el-button
              type="text"
              size="small"
              class="code-btn"
              :disabled="codeCountdown > 0"
              @click="sendCode"
            >
              {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 注册按钮 -->
        <el-button
          :loading="loading"
          type="primary"
          class="register-btn"
          @click.native.prevent="handlePhoneRegister"
        >
          注册
        </el-button>
      </el-form>

      <!-- 账号密码注册表单 -->
      <el-form
        v-if="activeTab === 'account'"
        ref="accountForm"
        :model="accountForm"
        :rules="accountRules"
        class="register-form"
      >
        <!-- 账号输入 -->
        <el-form-item prop="username">
          <div class="input-wrapper">
            <img
              src="@/assets/image/zh1.png"
              class="input-icon"
              alt="账号图标"
            >
            <el-input
              v-model="accountForm.username"
              placeholder="请输入你的账号"
              name="username"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </div>
        </el-form-item>

        <!-- 密码输入 -->
        <el-form-item prop="password">
          <div class="input-wrapper">
            <img
              src="@/assets/image/psw1.png"
              class="input-icon"
              alt="密码图标"
            >
            <el-input
              :key="passwordType"
              ref="password"
              v-model="accountForm.password"
              :type="passwordType"
              placeholder="请输入密码"
              name="password"
              tabindex="2"
              auto-complete="off"
            />
            <span
              class="show-pwd"
              @click="showPwd"
            >
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </div>
        </el-form-item>

        <!-- 邮箱输入 -->
        <el-form-item prop="email">
          <div class="input-wrapper">
            <img
              src="@/assets/image/zh1.png"
              class="input-icon"
              alt="邮箱图标"
            >
            <el-input
              v-model="accountForm.email"
              placeholder="请输入邮箱(非必填)"
              name="email"
              type="email"
              tabindex="3"
              auto-complete="on"
            />
          </div>
        </el-form-item>

        <!-- 注册按钮 -->
        <el-button
          :loading="loading"
          type="primary"
          class="register-btn"
          @click.native.prevent="handleAccountRegister"
        >
          注册
        </el-button>
      </el-form>

      <!-- 其他登录方式分割线 -->
      <div class="divider">
        <span class="divider-text">其他登录方式</span>
      </div>

      <!-- 社交登录图标 -->
      <div class="social-login">
        <div class="social-item">
          <img
            src="@/assets/image/wx1.png"
            alt="微信登录"
          >
        </div>
        <!-- <div class="social-item">
          <img
            src="@/assets/image/qq1.png"
            alt="QQ登录"
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { sendSmsCode, mobileRegister, accountRegister } from '@/api/user'

export default {
  name: 'Register',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        console.log(value)
        callback(new Error('请输入账号'))
      } else if (value.length < 3) {
        callback(new Error('账号不能少于3位'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value && value.trim() !== '') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(value)) {
          callback(new Error('请输入正确的邮箱格式'))
        } else {
          callback()
        }
      } else {
        callback() // 邮箱非必填
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位验证码'))
      } else {
        callback()
      }
    }
    return {
      activeTab: 'phone',
      phoneForm: {
        phone: '',
        code: ''
      },
      accountForm: {
        username: '',
        password: '',
        email: ''
      },
      phoneRules: {
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }]
      },
      accountRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        email: [{ trigger: 'blur', validator: validateEmail }]
      },
      loading: false,
      passwordType: 'password',
      codeCountdown: 0
    }
  },
  methods: {
    // 切换标签页
    switchTab(tab) {
      // 清除当前表单的验证错误
      if (this.$refs.phoneForm) {
        this.$refs.phoneForm.clearValidate()
      }
      if (this.$refs.accountForm) {
        this.$refs.accountForm.clearValidate()
      }
      // 切换标签页
      this.activeTab = tab
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handlePhoneRegister() {
      this.$refs.phoneForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用手机号注册API
          const data = {
            mobile: this.phoneForm.phone,
            captcha: this.phoneForm.code
          }
          mobileRegister(data).then(response => {
            this.loading = false
            this.$message.success('手机号注册成功')
            this.$router.push('/type')
          }).catch(error => {
            this.loading = false
            console.error('注册失败:', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAccountRegister() {
      this.$refs.accountForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用账号密码注册API
          const data = {
            username: this.accountForm.username,
            password: this.accountForm.password,
            email: this.accountForm.email || '' // 邮箱非必填，传空字符串
          }
          accountRegister(data).then(response => {
            this.loading = false
            this.$message.success('账号注册成功')
            this.$router.push('/type')
          }).catch(error => {
            this.loading = false
            console.error('注册失败:', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCode() {
      if (this.codeCountdown > 0) return

      this.$refs.phoneForm.validateField('phone', (errorMessage) => {
        if (errorMessage) {
          this.$message.error(errorMessage)
          return
        }

        // 调用发送短信验证码API
        const data = {
          mobile: this.phoneForm.phone,
          event: 'register'
        }

        sendSmsCode(data).then(response => {
          // 开始倒计时
          this.codeCountdown = 60
          const timer = setInterval(() => {
            this.codeCountdown--
            if (this.codeCountdown <= 0) {
              clearInterval(timer)
            }
          }, 1000)

          this.$message.success('验证码已发送')
        }).catch(error => {
          console.error('发送验证码失败:', error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg1.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
  overflow: hidden;
}

.register-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  width: 480px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 10%;

  .register-tabs {
    display: flex;
    margin-bottom: 30px;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 15px 0;
      font-size: 16px;
      color: #999;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &.active {
        color: #111111;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 2px;
          background: #0f6fe2;
          border-radius: 1px;
        }
      }

      &:hover {
        color: #4a90e2;
      }
    }
  }

  .register-form {
    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 0 15px;
      background: #fff;
      transition: all 0.3s ease;

      &:focus-within {
        border-color: #4a90e2;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
      }

      .input-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        flex-shrink: 0;
      }

      .el-input {
        flex: 1;

        ::v-deep .el-input__inner {
          border: none;
          background: transparent;
          padding: 15px 0;
          font-size: 14px;
          color: #333;

          &::placeholder {
            color: #999;
          }
        }
      }

      .show-pwd {
        cursor: pointer;
        color: #999;
        margin-left: 10px;
        padding: 5px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          color: #4a90e2;
          background: rgba(74, 144, 226, 0.1);
        }
      }

      &.code-input {
        .code-btn {
          margin-left: 10px;
          height: 36px;
          border-radius: 6px;
          font-size: 12px;
          color: #0f6fe2;
          font-weight: bold;
          background: transparent;
          border: none;
          padding: 0;

          &:hover {
            color: #0f6fe2;
            background: transparent;
          }

          &:disabled {
            color: #999;
          }
        }
      }
    }

    .register-btn {
      width: 100%;
      height: 48px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(90deg, #0f6fe2, #0c89f2);
      border: none;
      margin-top: 20px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
      }
    }
  }

  .divider {
    text-align: center;
    margin: 30px 0;
    position: relative;

    .divider-text {
      background: #fff;
      padding: 0 20px;
      color: #999;
      font-size: 12px;
      position: relative;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #e0e0e0;
      z-index: 0;
    }
  }

  .social-login {
    display: flex;
    justify-content: center;
    gap: 30px;

    .social-item {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        border-color: #357abd;
        transform: scale(1.1);
      }

      img {
        width: 50px;
        height: 50px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .register-card {
    width: 380px;
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .register-container {
    padding: 20px;
  }

  .register-card {
    width: 100%;
    max-width: 400px;
    padding: 25px;
  }
}
</style>
